import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { Paranja } from '../Paranja/Paranja.js';
import { Button } from '../Button/Button.js';
import { Icon } from '../Icon/Icon.js';
import S from './LightBox.styl.js';

function LightBox({ children, onClose, blur, ...props }) {
    const [isOpen, setOpen] = useState(false);
    const onKeyDown = useCallback(e => {
        if (isOpen && e.key === 'Escape') {
            e.stopPropagation();
            setOpen(false);
            onClose?.();
        }
    }, [isOpen, onClose]);
    useEffect(() => {
        setOpen(props.isOpen);
    }, [props.isOpen]);
    useEffect(() => {
        document.addEventListener('keydown', onKeyDown, true);
        return () => document.removeEventListener('keydown', onKeyDown, true);
    }, [isOpen]);
    return (jsxs(Paranja, { className: cn(S.root, isOpen && S.open), blur: blur, children: [children, jsx(Button, { className: S.close, onClick: onClose, variant: "clear", children: jsx(Icon, { type: "close", size: "l" }) })] }));
}

export { LightBox };
